import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
            平台优势
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            {featuresData.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.items.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-lg p-6 flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-accent-100 rounded-full mb-4">
                <i className={`${item.icon} text-accent-500 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}